import Marquee from "react-fast-marquee";

const words = [
  "Weddings", "Receptions", "Corporate Events", "Décor & Design",
  "Tent House", "Photography", "Celebrations",
];

export const EditorialMarquee = () => (
  <div
    data-testid="marquee"
    className="border-y border-champagne/20 bg-maroon py-8 sm:py-10 overflow-hidden"
  >
    <Marquee speed={45} gradient={false} autoFill>
      {words.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display italic text-4xl sm:text-6xl text-white px-8">
            {w}
          </span>
          <span className="text-champagne text-3xl sm:text-5xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
